import React from 'react';
import Modal from 'react-modal';
import {
  cycleDashboardWidgetSize,
  moveDashboardWidget,
  toggleDashboardWidget,
} from './dashboardLayouts';
import modalStyles from './DashboardCustomizeModal.module.css';

Modal.setAppElement('#root');

export default function DashboardCustomizeModal({
  isOpen,
  onClose,
  title,
  description,
  layout,
  widgetDefs,
  setLayout,
  t,
  tone = 'production',
}) {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={`${modalStyles.modalContent} ${tone === 'burnin' ? modalStyles.burninTone : ''}`}
      overlayClassName={modalStyles.modalOverlay}
      contentLabel={title}
    >
      <div className={modalStyles.modalHeader}>
        <div>
          <p className={modalStyles.eyebrow}>{t('Customizable dashboard')}</p>
          <h2>{title}</h2>
          <p>{description}</p>
        </div>
        <button type="button" className={modalStyles.closeButton} onClick={onClose}>
          {t('Close')}
        </button>
      </div>

      <div className={modalStyles.modalBody}>
        {layout.map((item, index) => {
          const widget = widgetDefs.find((entry) => entry.id === item.id);
          if (!widget) return null;

          return (
            <div key={item.id} className={modalStyles.customizeRow}>
              <label className={modalStyles.customizeLabel}>
                <input
                  type="checkbox"
                  checked={item.visible}
                  onChange={() => setLayout((current) => toggleDashboardWidget(current, item.id))}
                />
                <span>
                  <strong>{widget.title}</strong>
                  <small>{widget.description}</small>
                </span>
              </label>

              <div className={modalStyles.customizeActions}>
                <button
                  type="button"
                  className={modalStyles.smallActionButton}
                  onClick={() => setLayout((current) => cycleDashboardWidgetSize(current, item.id))}
                >
                  {item.size === 'wide' ? t('Shrink') : t('Expand')}
                </button>
                <button
                  type="button"
                  className={modalStyles.smallActionButton}
                  disabled={index === 0}
                  onClick={() => setLayout((current) => moveDashboardWidget(current, item.id, 'up'))}
                >
                  {t('Move up')}
                </button>
                <button
                  type="button"
                  className={modalStyles.smallActionButton}
                  disabled={index === layout.length - 1}
                  onClick={() => setLayout((current) => moveDashboardWidget(current, item.id, 'down'))}
                >
                  {t('Move down')}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </Modal>
  );
}
